{
  "INTEGRATION_APPS": {
    "FETCHING": "Pobieranie integracji",
    "NO_HOOK_CONFIGURED": "W tym koncie nie skonfigurowano integracji {integrationId}.",
    "HEADER": "Aplikacje",
    "STATUS": {
      "ENABLED": "Włączone",
      "DISABLED": "Wyłączone"
    },
    "CONFIGURE": "Skonfiguruj",
    "ADD_BUTTON": "Dodaj nowy hook",
    "DELETE": {
      "TITLE": {
        "INBOX": "Potwierdzenie usunięcia",
        "ACCOUNT": "Rozłącz"
      },
      "MESSAGE": {
        "INBOX": "Czy na pewno chcesz usunąć?",
        "ACCOUNT": "Czy na pewno chcesz się rozłączyć?"
      },
      "CONFIRM_BUTTON_TEXT": {
        "INBOX": "Tak, usuń",
        "ACCOUNT": "Tak, rozłącz"
      },
      "CANCEL_BUTTON_TEXT": "Anuluj",
      "API": {
        "SUCCESS_MESSAGE": "Hook został pomyślnie usunięty",
        "ERROR_MESSAGE": "Nie można połączyć się z serwerem Woot, spróbuj ponownie później"
      }
    },
    "LIST": {
      "FETCHING": "Pobieranie hooków integracyjnych",
      "INBOX": "Skrzynka odbiorcza",
      "EDIT": {
        "BUTTON_TEXT": "Edytuj"
      },
      "DELETE": {
        "BUTTON_TEXT": "Usuń"
      }
    },
    "ADD": {
      "FORM": {
        "INBOX": {
          "LABEL": "Wybierz skrzynkę odbiorczą",
          "PLACEHOLDER": "Wybierz skrzynkę odbiorczą"
        },
        "SUBMIT": "Dodaj",
        "CANCEL": "Anuluj"
      },
      "API": {
        "SUCCESS_MESSAGE": "Hook integracyjny został pomyślnie dodany",
        "ERROR_MESSAGE": "Nie można połączyć się z serwerem Woot, spróbuj ponownie później"
      }
    },
    "EDIT": {
      "TITLE": "Edytuj {name}",
      "FORM": {
        "INBOX": {
          "LABEL": "Wybierz skrzynkę odbiorczą",
          "PLACEHOLDER": "Wybierz skrzynkę odbiorczą"
        },
        "SUBMIT": "Aktualizuj",
        "CANCEL": "Anuluj"
      },
      "API": {
        "SUCCESS_MESSAGE": "Hak integracji został pomyślnie zaktualizowany",
        "ERROR_MESSAGE": "Nie można połączyć się z serwerem czatu, spróbuj ponownie później"
      }
    },
    "CONNECT": {
      "BUTTON_TEXT": "Połącz"
    },
    "DISCONNECT": {
      "BUTTON_TEXT": "Rozłącz"
    },
    "SIDEBAR_DESCRIPTION": {
      "CUSTOM_DATA_PROVIDER": "Pobierz dane z własnego serwera i wyświetl je na pasku bocznym konwersacji. Zwraca HTML (wyświetlany w ramce iframe) lub JSON (wyświetlany jako lista klucz/wartość).",
      "DIALOGFLOW": "Dialogflow is a natural language processing platform for building conversational interfaces. Integrating it with {installationName} lets bots handle queries first and transfer them to agents when needed. It helps qualify leads and reduce agent workload by answering FAQs. To add Dialogflow, create a Service Account in Google Console and share the credentials. Refer to the docs for details",
      "DAKTELA": "Synchronizuj e-maile i czaty z Twoim kontem daktela.",
      "RETINO": "Retino porządkuje zarządzanie zwrotami i reklamacjami.",
      "MAILSHIP": "Mailship to system zarządzania magazynem i realizacją zamówień. Sprawdź status zamówienia, śledzenie i szczegóły ekspedycji.",
      "RAYNET": "Połącz swoje konto Raynet CRM, aby uzyskać dostęp do danych klientów. Dodaj połączenie, podając nazwę użytkownika i token API Raynet."
    },
    "TEST_CONNECTION": {
      "BUTTON": "Testuj połączenie",
      "SUCCESS": "Połączenie udane",
      "ERROR": "Połączenie nie powiodło się. Sprawdź swoje dane logowania."
    }
  }
}
